// extracted by mini-css-extract-plugin
module.exports = {"container2":"styles_container2__2ohxr","container":"styles_container__1ZCgX","deg":"styles_deg__1JSp2","card":"styles_card__6ylR9","down":"styles_down__3coqx"};